import { useState } from "react";

export function ProfileImageUpdater() {
  const [imgPreview, setImgPreview] = useState<string>();

  const handleImgPreview = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setImgPreview(reader.result as string);
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="uploading-outer">
      <div className="uploadButton">
        <input
          id="upload"
          type="file"
          name="file"
          accept="image/*"
          onChange={handleImgPreview}
          hidden
        />
        {imgPreview ? (
          <label className="uploadButton" htmlFor="upload">
            <img
              src={imgPreview}
              alt=""
              width={196}
              height={116}
              style={{
                objectFit: "contain",
                width: "196px",
                height: "116px",
                paddingRight: "28px",
              }}
            />
          </label>
        ) : (
          <>
            <label
              className="uploadButton-button ripple-effect"
              htmlFor="upload"
            >
              Subir Imagen
            </label>
            <span className="uploadButton-file-name"></span>
          </>
        )}
      </div>

      <div className="text">
        Tamaño Max: 1MB, Dimensiones: 330x300, Extensiones: .jpg o .png
      </div>
    </div>
  );
}
